var styles = {"mBreakpointMd":"(min-width: 960px)","input":"styles_input__1DmwY mx-auto col-12 md-col-4 mt1 mb2","placement-modal":"styles_placement-modal__3yH3v","placementModal":"styles_placement-modal__3yH3v","placement-default":"styles_placement-default__1IRVG","placementDefault":"styles_placement-default__1IRVG"};

export default styles;
//# sourceMappingURL=styles.css.js.map
